/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_HowInputs */

const es_landing_cta_how = /** @type {(inputs: Landing_Cta_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona`)
};

const gl_landing_cta_how = /** @type {(inputs: Landing_Cta_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como funciona`)
};

const en_landing_cta_how = /** @type {(inputs: Landing_Cta_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Landing_Cta_HowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_cta_how = /** @type {((inputs?: Landing_Cta_HowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_HowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_cta_how(inputs)
	if (locale === "en") return en_landing_cta_how(inputs)
	return es_landing_cta_how(inputs)
});